import FlexPane from './_flex-pane.js'
import BonusCard from './_bonus-card.js'
import Text from './_text.js'
import Spinner from './_spinner.js'

export default {
  name: 'BonusHistory',
  values: {
    topWrapper: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          _mobile_padding: '8px 0 0',
        },
        itemSpacing: '8px',
      },
    },
    bonusCard: {
      configSet: BonusCard,
      configValues: {},
    },
    spinnerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
          display: 'flex',
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: 'auto',
          minHeight: '300px',
        },
      },
    },
    spinnerLabel: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 24px 0',
          flexGrow: 0,
        },
      },
    },
    spinner: {
      configSet: Spinner,
      configValues: {
        style: {
          container: {
            flexGrow: 0,
          },
        },
      },
    },
    noBonusesText: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'center',
        },
        container: {
          padding: '40px 0',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
